import { useCreateOrUpdateMultipleprintInBibliography } from "@/api/related-fields";
import { LinkableType } from "@/components/LinksManagement";
import { FieldConfig } from "@/config/forms/general";
import { MultipleprintInBibliography } from "@/lib/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import LinksDrawerLayout from "./LinksDrawerLayout";

const MultipleprintInBibliographyDrawer = ({
  fields,
  data,
  queryId,
  type,
}: {
  fields: FieldConfig[] | undefined;
  data: MultipleprintInBibliography;
  queryId: string;
  type: LinkableType;
}) => {
  const schema = z.object({
    bibliographieDansEstampesMultiplesDescriptionReproduitPage: z
      .string()
      .optional(),
    bibliographieDansEstampesMultiplesDescriptionCitePage: z
      .string()
      .optional(),
    bibliographieDansEstampesMultiplesDescriptionPhotographe: z
      .string()
      .optional(),
    bibliographieDansEstampesMultiplesDescriptionReproductionCoul: z
      .boolean()
      .optional(),
    bibliographieDansEstampesMultiplesDescriptionExemplaireRepr: z
      .string()
      .optional(),
    bibliography: z.object({
      bibliographieDescriptionNumeroBibliographie: z.string().optional(),
      bibliographieDescriptionResumeLong: z.string().optional(),
    }),
  });

  const { mutate: createOrUpdateMultipleprintInBibliography } =
    useCreateOrUpdateMultipleprintInBibliography(queryId, type);

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: {
      bibliography: data.bibliography,
      bibliographieDansEstampesMultiplesDescriptionReproduitPage:
        data.bibliographieDansEstampesMultiplesDescriptionReproduitPage,
      bibliographieDansEstampesMultiplesDescriptionCitePage:
        data.bibliographieDansEstampesMultiplesDescriptionCitePage,
      bibliographieDansEstampesMultiplesDescriptionPhotographe:
        data.bibliographieDansEstampesMultiplesDescriptionPhotographe,
      bibliographieDansEstampesMultiplesDescriptionReproductionCoul:
        data.bibliographieDansEstampesMultiplesDescriptionReproductionCoul,
      bibliographieDansEstampesMultiplesDescriptionExemplaireRepr:
        data.bibliographieDansEstampesMultiplesDescriptionExemplaireRepr,
    },
  });

  const onSubmit = (formData: z.infer<typeof schema>) => {
    createOrUpdateMultipleprintInBibliography({
      id: data.id,
      multipleprintId: data.multipleprint.id,
      bibliographyId: data.bibliography.id,
      ...formData,
    });
  };

  return (
    <LinksDrawerLayout
      form={form}
      fields={fields ?? []}
      recordId={data.id}
      onSubmit={onSubmit}
    />
  );
};

export default MultipleprintInBibliographyDrawer;
